import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import errorPage from "../../assets/images/404.gif";

const PageNotFound = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
  }, []);

  const navigate = useNavigate();
  return (
    <div className="main_content" id="main-content">
      <div className="page">
        <div className="flex-column">
          <div className="kiddies_hero"></div>

          <div className="kiddies_hero-tablet"></div>

          <div className="kiddies_hero-mobile"></div>

          <div className="col-lg-12  m-b-50 ">
            <div className="tab-content" id="myTabContent">
              <div
                className="fade show active"
                id="account_spec"
                role="tabpanel"
                aria-labelledby="account_spec-tab"
              >
                <div className="col-lg-12 m-b-30 d-flex align-items-center justify-content-between">
                  <div className="first-div" style={{ width: "70%" }}>
                    <div className="col-lg-7 col-md-12 col-sm-12">
                      <div className="section-title font-weight-900 font-36 m-b-30  text-suntrust">
                        404 PAGE
                      </div>

                      <div className="font-20 m-b-30">
                        The page you are looking for does not exist
                      </div>

                      <div className="form-group m-b-20">
                        <button
                          onClick={() => navigate("/openKiddiesAccount")}
                          className="btn btn-lg btn-suntrust font-weight-500"
                        >
                          Back Home
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="second-div" style={{ width: "40%" }}>
                    <img
                      src={errorPage}
                      alt="error"
                      style={{ width: "70%", height: "70%" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
